<template>
  <portal to="heroBlock">
    <div class="sub-page-hero" slot-scope="props" :style="{ opacity: props.opacity }">
      <div class="sub-page-hero__inner" :class="props.subPageControlsExist ? '' : 'sub-page-hero__inner--without-controls'">
        <slot></slot>
      </div>
      <div class="sub-page-hero__footer" v-if="$slots.footer">
        <div class="divider mt-1"></div>
        <div class="sub-page-hero__inner" :class="props.subPageControlsExist ? '' : 'sub-page-hero__inner--without-controls'">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </portal>
</template>

<script>
export default {
  data () {
    return {
      minOpacity: 0,
      maxOpacity: 1,
      opacity: 1
    }
  },

  methods: {
    getOpacity (scrollTop) {
      const opacity = this.maxOpacity - ((this.maxOpacity - this.minOpacity) / 400 * scrollTop)
      if (opacity < this.minOpacity) {
        this.opacity = this.minOpacity
      } else {
        this.opacity = opacity
      }

      return this.opacity
    }
  }
}
</script>

<style lang="scss">
.sub-page-hero {
  background-color: $color-azure-light;
  box-shadow: $elevation;
  position: relative;
  z-index: 1;

  & > * {
    width: 100%;
  }

  &__inner {
    max-width: 120rem;
    margin-left: auto;
    margin-right: auto;

    padding: $default-spacing-mobile;

    @include respond(tab-port) {
      padding: $default-spacing;
    }

    /*&--without-controls {*/
    /*  max-width: 78rem;*/
    /*}*/
  }
}
</style>
